import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
    iconfont: "mdi"
});

// Register for Vue draggable
import { VExpansionPanel } from "vuetify/lib";
Vue.component("v-expansion-panel", VExpansionPanel as Vue.VueConstructor);
